(function(){
  'use strict';
  var THRESHOLD=3500, TIRAS='tirasnasalesdeportivas', CLS='bam-fsb';
  function euro(c){return '€'+(c/100).toFixed(2).replace('.',',');}
  function css(){
    if(document.getElementById('bam-fsb-css'))return;
    var s=document.createElement('style');s.id='bam-fsb-css';
    s.textContent='.'+CLS+'{margin:12px 12px 4px;padding:12px 16px;background:#eef4f0;border:1px solid #d9e6df;border-radius:14px;font-size:13.5px;line-height:1.35;color:#14231b;font-family:inherit}'+
      '.'+CLS+'__msg{margin:0 0 8px;text-align:center}'+
      '.'+CLS+'__msg strong{font-weight:700}'+
      '.'+CLS+'__msg--ok{color:#1f8a4c}'+
      '.'+CLS+'__track{height:8px;background:#dbe6e0;border-radius:999px;overflow:hidden}'+
      '.'+CLS+'__fill{height:100%;background:#1f8a4c;border-radius:999px;transition:width .35s ease}';
    document.head.appendChild(s);
  }
  function markup(cart){
    var total=cart.total_price||0,left=THRESHOLD-total,
        pct=Math.max(0,Math.min(100,Math.round(total/THRESHOLD*100))),msg,ok=false;
    if(left>0){msg='🚚 Ti mancano <strong>'+euro(left)+'</strong> per la <strong>spedizione gratuita</strong>';}
    else{msg='🎉 Complimenti! Hai la <strong>spedizione gratuita</strong>';ok=true;}
    return '<p class="'+CLS+'__msg'+(ok?' '+CLS+'__msg--ok':'')+'">'+msg+'</p>'+
           '<div class="'+CLS+'__track"><div class="'+CLS+'__fill" style="width:'+pct+'%"></div></div>';
  }
  function hasTiras(cart){return (cart.items||[]).some(function(i){return i.handle===TIRAS;});}
  function anchors(){
    var out=[];
    var d=document.querySelector('#CartDrawer-CartItems');
    if(d&&d.parentNode)out.push([d.parentNode,d]);
    var pg=document.querySelector('cart-items')||document.querySelector('#main-cart-items')||document.querySelector('.cart__items');
    if(pg&&pg.parentNode)out.push([pg.parentNode,pg]);
    return out;
  }
  function paint(cart){
    var show=cart&&hasTiras(cart);
    if(!show){document.querySelectorAll('.'+CLS).forEach(function(n){n.remove();});return;}
    css();var m=markup(cart);
    anchors().forEach(function(p){
      var parent=p[0],before=p[1],bar=parent.querySelector(':scope > .'+CLS);
      if(!bar){bar=document.createElement('div');bar.className=CLS;parent.insertBefore(bar,before);}
      if(bar.getAttribute('data-h')!==m){bar.innerHTML=m;bar.setAttribute('data-h',m);}
    });
  }
  var t=null;
  function refresh(){if(t)return;t=setTimeout(function(){t=null;
    fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(function(r){return r.json();}).then(paint).catch(function(){});
  },120);}
  function observe(){
    if(!window.MutationObserver)return;
    ['#CartDrawer','#main-cart-items','cart-items','cart-drawer-items'].forEach(function(sel){
      var n=document.querySelector(sel);
      if(n)new MutationObserver(refresh).observe(n,{childList:true,subtree:true});
    });
  }
  function boot(){
    refresh();observe();
    document.addEventListener('change',function(e){if(e.target&&e.target.name&&/updates/.test(e.target.name))refresh();},true);
    document.addEventListener('click',function(e){
      if(e.target.closest&&e.target.closest('[name="add"],product-form button,.quick-add__submit,#cart-icon-bubble,[href$="/cart"],.quantity__button,quantity-input button,.cart-item__quantity button'))setTimeout(refresh,400);
    },true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
